module.exports = __webpack_public_path__ + "img/mexico_bank.787c282a.png";